/* Early Black Friday access. This is a browser preference, not authentication. */
(function (window, document) {
  'use strict';

  if (window.EarlyBF) {
    window.EarlyBF.refresh();
    return;
  }

  var STORAGE_KEY = 'early-bf:access:v1';
  var MAX_TIMEOUT = 2147483647;
  var memoryGrant = null;
  var state = null;
  var expiryTimer = null;
  var storageAvailable = true;
  var accessSuppressed = false;

  // Synchronous SHA-256 keeps the pre-content access decision and needs no
  // extra asset, network request or Web Crypto promise. Only activation and
  // migration of an old grant hash a value; ordinary reloads compare hashes.
  function tokenHash(value) {
    var bytes;
    try {
      bytes = encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, function (_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
      });
    } catch (error) { return null; }
    var constants = [
      0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
      0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
      0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
      0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
      0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
      0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
      0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
      0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2
    ];
    var hash = [0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19];
    var words = [], schedule = [], size = Math.ceil((bytes.length + 9) / 64) * 16;
    var i, offset, round;
    function rotate(word, count) { return (word >>> count) | (word << (32 - count)); }
    for (i = 0; i < bytes.length; i++) words[i >> 2] = (words[i >> 2] || 0) | (bytes.charCodeAt(i) << (24 - (i % 4) * 8));
    words[bytes.length >> 2] = (words[bytes.length >> 2] || 0) | (0x80 << (24 - (bytes.length % 4) * 8));
    words[size - 2] = Math.floor(bytes.length * 8 / 4294967296);
    words[size - 1] = (bytes.length * 8) | 0;
    for (offset = 0; offset < size; offset += 16) {
      for (i = 0; i < 16; i++) schedule[i] = words[offset + i] | 0;
      for (i = 16; i < 64; i++) {
        var x = schedule[i - 15], y = schedule[i - 2];
        schedule[i] = (schedule[i - 16] + (rotate(x, 7) ^ rotate(x, 18) ^ (x >>> 3)) +
          schedule[i - 7] + (rotate(y, 17) ^ rotate(y, 19) ^ (y >>> 10))) | 0;
      }
      var a = hash[0], b = hash[1], c = hash[2], d = hash[3], e = hash[4], f = hash[5], g = hash[6], h = hash[7];
      for (round = 0; round < 64; round++) {
        var t1 = (h + (rotate(e, 6) ^ rotate(e, 11) ^ rotate(e, 25)) + ((e & f) ^ (~e & g)) + constants[round] + schedule[round]) | 0;
        var t2 = ((rotate(a, 2) ^ rotate(a, 13) ^ rotate(a, 22)) + ((a & b) ^ (a & c) ^ (b & c))) | 0;
        h = g; g = f; f = e; e = (d + t1) | 0; d = c; c = b; b = a; a = (t1 + t2) | 0;
      }
      var block = [a,b,c,d,e,f,g,h];
      for (i = 0; i < 8; i++) hash[i] = (hash[i] + block[i]) | 0;
    }
    return hash.map(function (word) { return ('00000000' + (word >>> 0).toString(16)).slice(-8); }).join('');
  }

  // Require an explicit offset and validate calendar dates before Date.parse.
  function parseEnd(value) {
    if (typeof value !== 'string') return NaN;
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
    if (!match) return NaN;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var offsetHours = Number(match[9] || 0);
    var offsetMinutes = Number(match[10] || 0);
    if (year < 1000 || month < 1 || month > 12 || day < 1 ||
        day > new Date(Date.UTC(year, month, 0)).getUTCDate() ||
        Number(match[4]) > 23 || Number(match[5]) > 59 || Number(match[6]) > 59 ||
        offsetHours > 14 || offsetMinutes > 59 || (offsetHours === 14 && offsetMinutes !== 0)) {
      return NaN;
    }
    return Date.parse(value);
  }

  function readConfig() {
    var config = window.EarlyBFConfig || {};
    var campaignId = typeof config.campaignId === 'string' ? config.campaignId.trim() : '';
    var fingerprint = typeof config.accessTokenHash === 'string' ? config.accessTokenHash : '';
    var expiresAt = parseEnd(config.endsAt);
    return {
      enabled: config.enabled === true,
      valid: campaignId.length > 0 && /^[a-f0-9]{64}$/.test(fingerprint) && Number.isFinite(expiresAt),
      campaignId: campaignId,
      tokenHash: fingerprint,
      expiresAt: expiresAt
    };
  }

  function removeGrant() {
    memoryGrant = null;
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      storageAvailable = false;
    }
  }

  function readGrant() {
    if (memoryGrant !== null) {
      storageAvailable = false;
      return memoryGrant;
    }
    var serialized;
    try {
      serialized = window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      storageAvailable = false;
      return memoryGrant;
    }
    if (serialized === null) return memoryGrant;
    try {
      var parsed = JSON.parse(serialized);
      if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
        removeGrant();
        return null;
      }
      return parsed;
    } catch (error) {
      removeGrant();
      return null;
    }
  }

  function matches(grant, config) {
    if (grant === null || typeof grant !== 'object' || grant.campaignId !== config.campaignId ||
        grant.expiresAt !== config.expiresAt || grant.expiresAt <= Date.now()) return false;
    if (grant.version === 2) return grant.tokenHash === config.tokenHash;
    // Preserve existing visitors, then replace their old plaintext storage.
    return grant.version === 1 && typeof grant.token === 'string' && tokenHash(grant.token) === config.tokenHash;
  }

  function saveGrant(config) {
    memoryGrant = {
      version: 2,
      campaignId: config.campaignId,
      tokenHash: config.tokenHash,
      expiresAt: config.expiresAt
    };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryGrant));
      storageAvailable = true;
      memoryGrant = null;
      return true;
    } catch (error) {
      storageAvailable = false;
      // If a legacy plaintext grant existed, do not leave it behind when
      // replacement is denied but removing that entry is still permitted.
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (removeError) { /* Storage may deny both operations. */ }
      return false;
    }
  }

  function cleanUrl(url) {
    if (!url.searchParams.has('bf_access') && !url.searchParams.has('bf_reset')) return;
    url.searchParams.delete('bf_access');
    url.searchParams.delete('bf_reset');
    try {
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // Access still works if this browser does not allow history changes.
    }
  }

  function publish(config, active, reason, persistent) {
    if (expiryTimer !== null) window.clearTimeout(expiryTimer);
    expiryTimer = null;
    var next = {
      active: active,
      reason: reason,
      campaignId: config.campaignId,
      expiresAt: Number.isFinite(config.expiresAt) ? config.expiresAt : null,
      persistent: persistent,
      storageAvailable: storageAvailable
    };
    var changed = !state || JSON.stringify(state) !== JSON.stringify(next);
    state = Object.freeze(next);
    document.documentElement.classList.toggle('bf-vip', active);
    document.documentElement.setAttribute('data-bf-access', active ? 'active' : 'inactive');
    if (active) {
      expiryTimer = window.setTimeout(refresh, Math.min(MAX_TIMEOUT, Math.max(1, config.expiresAt - Date.now())));
    }
    if (changed) {
      document.dispatchEvent(new window.CustomEvent('bf:access-changed', { detail: getState() }));
    }
    return getState();
  }

  function refresh() {
    storageAvailable = true;
    var config = readConfig();
    var url = new window.URL(window.location.href);
    var tokens = url.searchParams.getAll('bf_access');
    var reset = url.searchParams.getAll('bf_reset').indexOf('1') !== -1;
    // Consume the activation parameter once, even when history changes fail.
    // On subsequent refreshes only a stored or in-memory grant may reactivate.
    var token = !activationConsumed && tokens.length === 1 ? tokens[0] : null;
    activationConsumed = true;
    cleanUrl(url);

    if (reset) {
      accessSuppressed = true;
      removeGrant();
      return publish(config, false, 'reset', false);
    }
    if (!config.enabled || !config.valid || config.expiresAt <= Date.now()) {
      removeGrant();
      return publish(config, false, !config.enabled ? 'disabled' : !config.valid ? 'invalid-config' : 'expired', false);
    }
    if (token !== null && tokenHash(token) === config.tokenHash) {
      accessSuppressed = false;
      var persistent = saveGrant(config);
      return publish(config, true, persistent ? 'granted' : 'granted-memory', persistent);
    }
    if (accessSuppressed) return publish(config, false, 'reset', false);
    var grant = readGrant();
    if (matches(grant, config)) {
      var isPersistent = grant.version === 1 ? saveGrant(config) : grant !== memoryGrant;
      return publish(config, true, isPersistent ? 'restored' : 'granted-memory', isPersistent);
    }
    if (grant !== null) removeGrant();
    return publish(config, false, tokens.length > 0 ? 'invalid-link' : 'no-access', false);
  }

  function getState() {
    return Object.freeze(Object.assign({}, state));
  }

  function deactivate() {
    accessSuppressed = true;
    removeGrant();
    cleanUrl(new window.URL(window.location.href));
    return publish(readConfig(), false, 'reset', false);
  }

  var activationConsumed = false;
  window.EarlyBF = Object.freeze({ getState: getState, refresh: refresh, deactivate: deactivate });
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY || event.key === null) {
      memoryGrant = null;
      refresh();
    }
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  // An asset failure must never leave VIP prices with an unguarded checkout.
  function checkoutFallback(event) {
    if (!state || !state.active || (window.EarlyBFCart && typeof window.EarlyBFCart.synchronize === 'function')) return;
    var target = event.target;
    var checkout = target && target.closest && target.closest('[name="checkout"], [name="goto_pp"], [name="goto_gc"], a[href*="/checkout"], .shopify-payment-button, [data-add-ckt4]');
    var cartForm = event.type === 'submit' && target && target.matches && target.matches('[data-cart-wrapper]');
    if (!checkout && !cartForm) return;
    event.preventDefault(); event.stopImmediatePropagation();
    deactivate();
    if (document.querySelector) {
      var warning = document.querySelector('[data-bf-runtime-warning]');
      if (warning) warning.hidden = false;
    }
  }
  document.addEventListener('click', checkoutFallback, true);
  document.addEventListener('submit', checkoutFallback, true);
  refresh();
})(window, document);
